const DateFilterButton = ({ isActive = false, children, onClick, disabled=false, ...rest }) => {

  return (
    <button 
      className={`
        flex items-center px-2 py-1 rounded-md cursor-pointer
        ${isActive ? "bg-[rgba(100,168,255,0.15)] text-[#2272eb]" : "bg-[rgba(2,32,71,0.05)] hover:bg-[rgba(2,32,71,0.1)]"}
      `}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >{children}</button>
  )
}

export default DateFilterButton